import { http } from './http'
import { random } from './common'

const DELETE_TIME = 3 * 1000 // 3 s
let recordConfigPromiseMap = new Map() // 记录同菜单发起的请求，阻止多个组件同时发生相同请求

// 通用【首页】菜单请求头
export const AXIOS = {
  axios: {
    headers: {
      'X-menu-id': '2820215716730110'
    }
  }
}

// 通用查询分享V2接口: 增加限制条件数量分享验证
export const SHARED2_URL = 'system.genericSearchTemplate.shareToV2'

export function getGenericSearchConfig (menuId, searchCodes, options = {}) {
  const { sharedConfigInSameModule } = options
  // const sharedConfigInSameModule = true
  const hasSearchCodes = Array.isArray(searchCodes) && searchCodes.length > 0
  const isCache = !hasSearchCodes && menuId
  // 同一时间重复的请求会被取消，所以带上时间戳
  let params = { time: random(), menuId }

  if (hasSearchCodes) {
    params.searchCodes = searchCodes
  }

  // 拦截不同实例发起的请求，避免多个实例在同页面渲染时并发请求
  if (sharedConfigInSameModule && isCache && recordConfigPromiseMap.has(menuId)) {
    return recordConfigPromiseMap.get(menuId)
  }

  // 无论成功失败，都清缓存，避免请求失败后不发起请求
  let configPromise = http('system.genericSearch.listByMenuId', params)
    .then(res => res)
    .catch(err => {
      setTimeout(() => {
        recordConfigPromiseMap.delete(menuId)
      }, DELETE_TIME)
      throw err
    })
    .finally(() => {
      // 防止响应数据过快时，未拦截到并发请求
      setTimeout(() => {
        recordConfigPromiseMap.delete(menuId)
      }, DELETE_TIME)
    })

  // 数据有通过 searchCodes 筛选的，响应报文相对较少，不做处理
  if (sharedConfigInSameModule && isCache) {
    recordConfigPromiseMap.set(menuId, configPromise)
  }
  return configPromise
}



// WEBPACK FOOTER //
// ./src/public/utils/common-api.js